/**
 *
 * @param valueObj
 * @param rowObj
 * @param templateField
 * @param templateFields
 * @param trigger
 * @returns {null|*}
 */
export function transformDate(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  const cellValue = valueObj.cell_value

  // returns either the original value unchanged, or a date that was parsed to our best ability
  return cellValue
}
